import { useEffect } from 'react';

export default function useNavigationDrawer(open, onClose, drawerRef, triggerRef) {
    useEffect(() => {
        if (!open) return;
        const trigger = triggerRef.current;
        const oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        drawerRef.current?.querySelector('button')?.focus();
        const onKeyDown = (event) => {
            if (event.defaultPrevented) return;
            // Account menus and dialogs may be portaled beside the drawer.
            const overlay = event.target.closest?.('.p-menu, .p-dialog, .p-dropdown-panel, .p-multiselect-panel');
            if (overlay && !drawerRef.current?.contains(overlay)) return;
            if (event.key === 'Escape') {
                event.preventDefault();
                onClose();
            }
            if (event.key !== 'Tab') return;
            const focusable = Array.from(drawerRef.current?.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]') || [])
                .filter((element) => !element.closest('[hidden]'));
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && (document.activeElement === first || !drawerRef.current?.contains(document.activeElement))) {
                event.preventDefault(); last?.focus();
            } else if (!event.shiftKey && (document.activeElement === last || !drawerRef.current?.contains(document.activeElement))) {
                event.preventDefault(); first?.focus();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        const media = window.matchMedia('(min-width: 1280px)');
        const onResize = () => { if (media.matches) onClose(); };
        if (media.addEventListener) media.addEventListener('change', onResize);
        else media.addListener(onResize);
        return () => {
            document.body.style.overflow = oldOverflow;
            document.removeEventListener('keydown', onKeyDown);
            if (media.removeEventListener) media.removeEventListener('change', onResize);
            else media.removeListener(onResize);
            trigger?.focus();
        };
    }, [open, onClose, drawerRef, triggerRef]);
}
